export enum CreateExplanatoryNoteStatus {
    Success = "Success",
    Error = "Error",
    ExpertError = "ExpertError",
}

export type CreateExplanatoryNoteResponse =
    | {
          driveUri: string;
          errorMessage: null;
          status: CreateExplanatoryNoteStatus.Success;
      }
    | {
          driveUri: null;
          errorMessage: string;
          status: CreateExplanatoryNoteStatus.Error | CreateExplanatoryNoteStatus.ExpertError;
      };
